import { UTF_8 } from 'src/constants/Generals';
import _ from 'lodash';
import i18next from 'i18next';

export const JOIN_INSURANCE = [
  { value: '1', label: i18next.t('constants.Options.JoinInsurance.add') },
  { value: '0', label: i18next.t('constants.Options.JoinInsurance.not_added_yet') }
];

export const INVITATION_STATUSES = [
  { value: 'not_invited', label: i18next.t('constants.Options.InvitationStatus.not_invited') },
  { value: 'invited', label: i18next.t('constants.Options.InvitationStatus.invited') },
  { value: 'only_enrollment_input', label: i18next.t('constants.Options.InvitationStatus.registration_by_manual') },
  { value: 'registered', label: i18next.t('constants.Options.InvitationStatus.registered') }
];

export const BONUS_TRANSFER_TYPES = [
  { value: 12, label: i18next.t('constants.Options.BonusTransferTypes.bonus_transfer') },
  { value: 21, label: i18next.t('constants.Options.BonusTransferTypes.total_transfer') }
];

export const CHANGED = [{ value: 0, label: i18next.t('constants.Options.Changed.no') }, { value: 1, label: i18next.t('constants.Options.Changed.yes') }];
export const PAY_FOR_RETIREMENT = [
  { value: 0, label: i18next.t('constants.Options.PayForRetirement.no') },
  { value: 1, label: i18next.t('constants.Options.PayForRetirement.yes') }
];

const MARITAL_STATUSES = [
  { value: 'married', label: i18next.t('constants.Options.MaritalStatus.single') },
  { value: 'single', label: i18next.t('constants.Options.MaritalStatus.married') }
];

export const IS_ON_OFF = [{ value: '1', label: i18next.t('constants.Options.on') }, { value: '0', label: i18next.t('constants.Options.off') }];

export const IS_SHOW = [{ value: '1', label: i18next.t('constants.Options.show') }, { value: '0', label: i18next.t('constants.Options.hide') }];

export const ENCODING_OPTIONS = [{ label: i18next.t('constants.Options.utf'), value: UTF_8 }];

export const FB_DATA_LINE_FEED_OPTIONS = [
  { label: 'CR+LF', value: 'crlf' },
  { label: 'CR', value: 'cr' },
  { label: 'LF', value: 'lf' },
  { label: 'なし', value: 'none' }
];

export const FB_DATA_END_OF_FILE_LINE_FEED = [
  { value: '0', label: i18next.t('constants.Options.FBDataForLineFeed.no') },
  { value: '1', label: i18next.t('constants.Options.FBDataForLineFeed.yes') }
];

export const DEDUCTION_ALLOWANCE_EXPORT_TYPES = [{ value: 'each_employee', label: i18next.t('constants.Options.Export_by_employee') }];

export const DEDUCTION_ALLOWANCE_EXPORT_DIRECTIONS = [
  {
    value: 'horizontal',
    label: i18next.t('constants.Options.Display_the_selected_items_vertically_names_are_lined_up_horizontally')
  },
  {
    value: 'vertical',
    label: i18next.t('constants.Options.Display_the_selected_items_side_by_side_names_are_lined_up_vertically')
  }
];

export const CSV_FORMAT_TYPES = [{ value: 'pay', label: i18next.t('constants.Options.Salary_provision_deduction_item_format') }];

export const REVISION_SORT_TYPES = [
  { value: 'staff_code', label: i18next.t('constants.Options.RevisionSortTypes.staff_code') },
  { value: 'target', label: i18next.t('constants.Options.RevisionSortTypes.priority_eligible') },
  { value: 'insured_personnel_number', label: i18next.t('constants.Options.RevisionSortTypes.insurance_reference_number') }
];

export const NOTIFICATION_OF_BASE_AMOUNT_REVISION_SORT_TYPES = [
  { value: 'staff_code', label: i18next.t('constants.Options.NotificationOfBaseRevision.staff_code') },
  { value: 'insured_personnel_number', label: i18next.t('constants.Options.NotificationOfBaseRevision.insurance_reference_number') }
];

export const REVISION_FILTER_TYPES = [
  { value: 'only_targets', label: i18next.t('constants.Options.RevisionFilterTypes.only_the_eligible') },
  { value: 'exclude_targets', label: i18next.t('constants.Options.RevisionFilterTypes.only_the_ineligible') },
  { value: 'all', label: i18next.t('constants.Options.RevisionFilterTypes.all') }
];

export const NOTIFICATION_OF_BASE_AMOUNT_REVISION_FILTER_TYPES = [
  { value: 'only_targets', label: i18next.t('constants.Options.NotificationOfBaseRevisionFilterTypes.only_the_eligible') },
  { value: 'exclude_targets', label: i18next.t('constants.Options.NotificationOfBaseRevisionFilterTypes.only_the_ineligible') },
  { value: 'alert_targets', label: i18next.t('constants.Options.NotificationOfBaseRevisionFilterTypes.only_the_eligible_for_error') },
  { value: 'all', label: i18next.t('constants.Options.NotificationOfBaseRevisionFilterTypes.all') }
];

export const EMPLOYMENT_STATUSES = [
  { value: '0', label: i18next.t('constants.Options.EmploymentStatus.all') },
  { value: '2', label: i18next.t('constants.Options.EmploymentStatus.available') },
  { value: '3', label: i18next.t('constants.Options.EmploymentStatus.leave') },
  { value: '4', label: i18next.t('constants.Options.EmploymentStatus.retire') },
  { value: '1', label: i18next.t('constants.Options.EmploymentStatus.unofficial_offer') }
];

export const ROLL_ACCOUNT_TYPE = [
  { value: '1', label: i18next.t('constants.Options.RoleAccountType.staff_information_available') },
  { value: '2', label: i18next.t('constants.Options.RoleAccountType.staff_information_unavailable') }
];

export const LABOR_INSURANCE_SUMMARY_TYPES = [
  { value: '1', label: i18next.t('constants.Options.LaborInsuranceSummaryType.basic_salary_calculation') },
  { value: '2', label: i18next.t('constants.Options.LaborInsuranceSummaryType.tax_return_for_labor_insurance') }
];

export const PAYMENT_IN_INSTALLMENT_FOR_ESTIMATE_INSURANCE_FEE = [
  { value: '0', label: i18next.t('constants.Options.InstallmentForInsuranceFee.one_time') },
  { value: '1', label: i18next.t('constants.Options.InstallmentForInsuranceFee.three_time') }
];

export const PAYMENT_ON_WEEKEND_CASES = [
  { value: 'prev_weekday', label: i18next.t('constants.Options.PaymentOnWeekendCases.prev_weekday') },
  { value: 'next_weekday', label: i18next.t('constants.Options.PaymentOnWeekendCases.next_weekday') },
  { value: 'not_change', label: i18next.t('constants.Options.PaymentOnWeekendCases.not_change') }
];

export const INHABITANT_TAX_COLLECTION_METHODS = [
  { value: 'special', label: i18next.t('constants.Options.InhabitantTaxCollectionMethod.special_collection') },
  { value: 'normal', label: i18next.t('constants.Options.InhabitantTaxCollectionMethod.normal_collection') }
];

export const INHABITANT_TAX_MONTH_SETTING_TYPE = [
  { value: 'simple', label: i18next.t('constants.Options.InhabitantTaxMonthSettingType.simple_setting') },
  { value: 'month', label: i18next.t('constants.Options.InhabitantTaxMonthSettingType.monthly_setting') }
];

export const INHABITANT_TAX_TABLE_PDF_LAYOUT_TYPES = [
  { value: 'by_employee', label: i18next.t('constants.Options.InhabitantTaxTablePDFLayoutTypes.show_the_amount_per_employee') },
  { value: 'by_municipality', label: i18next.t('constants.Options.InhabitantTaxTablePDFLayoutTypes.show_total_by_city') }
];

export const RELEASE_STATUSES = [
  { value: '1', label: i18next.t('constants.Options.ReleaseStatuses.disclose') },
  { value: '0', label: i18next.t('constants.Options.ReleaseStatuses.undisclosed') }
];

export const HH_00_HOURS = _.times(24, hour => {
  const hh = hour > 9 ? hour : '0'.concat(hour);
  return { value: `${hh}:00`, label: `${hh}:00` };
});

export const REVISION_OPTIONS = [
  { value: true, label: i18next.t('constants.Options.RevisionOptions.yes') },
  { value: false, label: i18next.t('constants.Options.RevisionOptions.no') }
];

export const SOCIAL_INSURANCE_NOTIFICATION_SUBMISSION_TYPES = [
  { value: 'pension_office', label: i18next.t('constants.Options.SocialInsuranceSubmissionTypes.pension_office') },
  { value: 'health_insurance_assoc', label: i18next.t('constants.Options.SocialInsuranceSubmissionTypes.health_insurance_association') }
];

export const SOCIAL_INSURANCE_NOTIFICATION_SORT_TYPES = [
  { value: 'insured_personnel_number', label: i18next.t('constants.Options.SocialInsuranceSortTypes.insurance_reference_number') },
  { value: 'staff_code', label: i18next.t('constants.Options.SocialInsuranceSortTypes.staff_code') }
];

export const INVITE_USER_ROLES = [
  { value: 'admin', label: i18next.t('constants.Options.RoleUsers.manager') },
  { value: 'operator', label: i18next.t('constants.Options.RoleUsers.operation_staff') }
];

export const BANK_SELECTS = [
  { value: 'acb', label: 'ACB' },
  { value: 'bidv', label: 'BIDV' },
  { value: 'hdbank', label: 'HDBank' },
  { value: 'ocb', label: 'OCB' },
  { value: 'vcb', label: 'VCB' },
  { value: 'vpbank', label: 'VPBank' }
];

export const HDBANK_ACCOUNT_TYPES = [
  { value: 'internal', label: i18next.t('constants.Options.HDBankAccountTypes.internal') },
  { value: 'external', label: i18next.t('constants.Options.HDBankAccountTypes.external') }
];

export const IS_SAME_DAY = [
  { value: 'same_day', label: i18next.t('constants.Options.IsSameDay.same_day') },
  { value: 'next_day', label: i18next.t('constants.Options.IsSameDay.next_day') }
];

export const CUT_OFF_TIME = [
  { value: 'smc04', label: i18next.t('constants.Options.CutOffTime.same_day') },
  { value: 'smc06', label: i18next.t('constants.Options.CutOffTime.next_day') }
];

export const TAX_ON_TAX_OPTIONS = [
  { value: 'no_support', label: i18next.t('constants.Options.TaxOnTaxOptions.tax_on_tax_no_support') },
  { value: 'full_support', label: i18next.t('constants.Options.TaxOnTaxOptions.tax_on_tax_full_support') }
];

export const PND_OPTIONS = [
  { value: 'all_employee', label: i18next.t('constants.Options.PndOptions.export_all_employee') },
  { value: 'select_branch', label: i18next.t('constants.Options.PndOptions.export_by_specifying_office') }
];

export const FB_DATA_OPTIONS = [
  { value: 'all_employee', label: i18next.t('constants.Options.PndOptions.export_all_employee') },
  { value: 'select_branch', label: i18next.t('constants.Options.PndOptions.export_by_specifying_office') }
];

export const IS_MARRIED = [
  { value: 'married', label: i18next.t('constants.Options.married') },
  { value: 'unmarried', label: i18next.t('constants.Options.unmarried') }
];

export const PND_FORMAT_TYPE = [
  { value: 'summary', label: i18next.t('constants.Options.PNDFormatType.pnd1') },
  { value: 'detail', label: i18next.t('constants.Options.PNDFormatType.attachment_of_pnd1') }
];

export const PND_KOR_FORMAT_TYPE = [
  { value: 'summary', label: i18next.t('constants.Options.PND1KorFormatType.pnd1kor') },
  { value: 'detail', label: i18next.t('constants.Options.PND1KorFormatType.attachment_of_pnd1kor') }
];

export const TAX_TYPE = [
  { value: 'vat', label: i18next.t('constants.Options.TaxType.vat') },
  { value: 'sbt', label: i18next.t('constants.Options.TaxType.sbt') },
  { value: 'not_registered_vat', label: i18next.t('constants.Options.TaxType.not_registered_vat') }
];

export const INCOME_TAX_DECLARATION_FILE_FORMAT = [
  { value: 'xml', label: i18next.t('constants.Options.IncomeTaxDeclarationFileFormat.xml') },
  { value: 'excel', label: i18next.t('constants.Options.IncomeTaxDeclarationFileFormat.excel') }
];

export const OUTPUT_FORMAT_TYPE = [{ value: 'txt', label: '.txt' }, { value: 'rdx', label: '.rdx' }];
export const LANGUAGE_OPTIONS = [
  { value: 'ja', label: i18next.t('constants.Options.LanguageOptions.ja') },
  { value: 'en', label: i18next.t('constants.Options.LanguageOptions.en') },
  { value: 'vi', label: i18next.t('constants.Options.LanguageOptions.vi') },
  { value: 'th', label: i18next.t('constants.Options.LanguageOptions.th') }
];

export const ICASH_TYPE = [{ value: 'payroll', label: 'Payroll' }, { value: 'smart', label: 'Smart' }];
export const SEMI_MONTHLY_TAX_DEDUCTION_OPTIONS = [
  { value: 1, label: i18next.t('constants.Options.SemiMonthlyTaxDeduction.each_payment_day') },
  {
    value: 0,
    label: i18next.t('constants.Options.SemiMonthlyTaxDeduction.only_second_half_payment_day')
  }
];

export const PAYMENT_TERM = [
  { value: 'current_month', label: i18next.t('constants.Options.PaymentTerm.current_term') },
  { value: 'next_month', label: i18next.t('constants.Options.PaymentTerm.next_term') }
];

export const PAYMENT_COUNT_OPTIONS = [
  { value: 'once', label: i18next.t('constants.Options.PaymentCount.once') },
  // @TODO: Temporarily hide twice monthly payment feature, will be developed later
  // https://donuts-vn.atlassian.net/browse/JBC-92
  // { value: 'twice', label: i18next.t('constants.Options.PaymentCount.twice') }
];

export const PND_KOR_ONLINE_FORMAT = [
  { value: 'txt', label: '.txt' }
  // { value: 'rdx', label: '.rdx' }
];

export const EMPLOYEES_CATEGORIES = [
  { value: 'group', label: 'group' },
  { value: 'employment_type', label: 'employment_type' },
  { value: 'position', label: 'position' },
  { value: 'occupation', label: 'occupation' },
  { value: 'payroll_rules_group', label: 'payroll_rules_group' }
];

export const SOCIAL_SECURITY_TARGETS = [
  { value: '1', label: i18next.t('features.Employees.components.SocialSecurityContribution.registered') },
  { value: '0', label: i18next.t('features.Employees.components.SocialSecurityContribution.not_registered') }
];

export const NATIONALITY_TYPES = [
  { value: 'vietnamese', label: i18next.t('features.Employees.components.SocialSecurityContribution.vietnamese') },
  { value: 'foreigner', label: i18next.t('features.Employees.components.SocialSecurityContribution.foreigner') }
];

export const LIST_RATE_TYPES = [
  { value: 'social_insurance', label: 'Social insurance' },
  { value: 'unemployment_insurance', label: 'Unemployment insurance' },
  { value: 'health_insurance', label: 'Health insurance' }
];

export default MARITAL_STATUSES;
